// Article Overview App
import * as Vue from 'vue';
import ArticleOverview from './containers/article-overview.vue';

const app = Vue.createApp(ArticleOverview);
app.mount('#article-overview-app');
